import React, { FC } from 'react';
import { StyledLink } from '../Components';
import { List, ListItem } from '@mui/material';
import { Typography } from '@mui/material';
import { useQuery } from '@apollo/client';
import LoadingSpinner from '../LoadingSpinner';
import { GET_CATEGORIES_FOR_USER } from './home.graphql';
import { StyledPaper } from '../theme';
import { useUserContext } from '../UserContext';

export const MyCategories: FC = () => {
  const { userId } = useUserContext();
  const { error, data } = useQuery(GET_CATEGORIES_FOR_USER, {
    variables: { ownerId: userId },
    fetchPolicy: 'cache-and-network',
  });

  return (
    <StyledPaper>
      <Typography variant="h5" component="h3">
        Mine fagområder
      </Typography>
      {error && <Typography>{error.message}</Typography>}
      {!data && <LoadingSpinner />}
      {data?.categories && data.categories?.length > 0 && (
        <List dense>
          {data.categories
            .filter((x) => !!x)
            .map((e) => (
              <ListItem key={e.id}>
                <StyledLink to={`/category/${e.id}`}>{e.title}</StyledLink>
              </ListItem>
            ))}
        </List>
      )}
    </StyledPaper>
  );
};
